<div class="accordion" id="formacc" *ngIf="notice">
  <div class="sticky-top fixedtop" id="errorsbloc">
    <app-form-errors [stepid]="getStepId()" *ngIf="getStepId()" [linkForRouter]="linkForRouter"></app-form-errors>
    <app-eform-error-no-clikable [stepid]="getStepId()" [linkForRouter]="linkForRouter"></app-eform-error-no-clikable>
  </div>
  <div class="accordion-item" [hidden]="true">
    <h2>
      <strong>les metaData</strong>
    </h2>
    <div id="collapseOne" class="accordion-collapse show" aria-labelledby="headingOne"
         data-bs-parent="#formacc">
      <div class="accordion-body">
        <div *ngFor="let field of notice?.metadata?.fields">
          <app-form-input [parentForm]="formGroup" [field]="field" [noticeValue]="noticeValue"
                          [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                          [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"></app-form-input>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div>
      <!--afficher les sections hors lot-->
      <div *ngFor="let section of notice.sections; let i = index">
        <app-section *ngIf="!section?.hidden" [formGroup]="formGroup"
                     [hidden]="haveToHide(i +1)"
                     [section]="section"
                     [indexPage]="indexPage"
                     [getRepeatablePathWithIndexForSection]="getRepeatablePathWithIndexForSection"
                     [noticeValue]="noticeValue"
                     [prefixId]="section.id"
                     [linkForRouter]="linkForRouter"
        ></app-section>
      </div>
      <!--afficher le lot (toujours un seul à la fois pour la perf)-->
      <div *ngIf="isDuplicableSectionReady===true">
        <app-section [formGroup]="formGroup"
                     [hidden]="haveToHideSectionDuplicable()"
                     [section]="duplicableSection"
                     [indexPage]="indexPage"
                     [getRepeatablePathWithIndexForSection]="getRepeatablePathWithIndexForSection"
                     [noticeValue]="duplicableSectionValue"
                     [prefixId]="duplicableSection?.id"
                     [linkForRouter]="linkForRouter"
        ></app-section>
      </div>
    </div>
  </div>
</div>
